import { StyleNames } from '@volosoft/ngx-lepton-x';
import { ACX_APPEARANCES, ACX_THEME_OPTIONS } from 'src/core/constants/theme/lpx-appearance.constants';
import { FULL_WIDTH_LAYOUT_CLASS, LPX_LAYOUT_STORAGE_KEY } from 'src/core/constants/theme/lpx-container.constants';

/**
 * Rewrites LeptonX preferences that no longer exist so accounts carrying an old choice land on a valid
 * one. Must run before ThemeService or SideMenuLayoutService are constructed.
 *
 * The layout half is not cosmetic: when the stored container width is missing from the offered list,
 * SideMenuLayoutService applies no width class at all, leaving the wrapper unstyled.
 */
export function normalizeLpxPreferences(): void {
  const appearanceKey = ACX_THEME_OPTIONS.localStorageKey;
  const appearance = localStorage.getItem(appearanceKey);

  if (appearance && !ACX_APPEARANCES.some(candidate => candidate.styleName === appearance)) {
    localStorage.setItem(appearanceKey, StyleNames.Light);
  }

  if (localStorage.getItem(LPX_LAYOUT_STORAGE_KEY) !== FULL_WIDTH_LAYOUT_CLASS) {
    localStorage.setItem(LPX_LAYOUT_STORAGE_KEY, FULL_WIDTH_LAYOUT_CLASS);
  }
}
